const validateSerialized = (serialized) => {
    return typeof serialized === 'string' && serialized.startsWith('xpub');
};
const serialize = (xpub) => xpub;
const deserialize = (xpub) => xpub;
const defaultExport = {
    validateSerialized,
    serialize,
    deserialize,
};
export default defaultExport;
